import React from 'react'
import { MutationUpdaterFn, Reference } from '@apollo/client'

import ConfirmDeleteCommentModal from './ConfirmDeleteCommentModal'
import {
  BoardCommentFragment,
  BoardCommentFragmentDoc,
  DeleteCommentMutation,
  useDeleteCommentMutation
} from '../../../../../generated/graphql'
import useModal from '../../../../../lib/hooks/useModal'

type ConfirmDeleteCommentModalWrapperProps = {
  /** ID of Plan Group */
  id: string
  /** Determines visibility of modal */
  isOpen: boolean
}

const ConfirmDeleteCommentModalWrapper = ({
  id,
  isOpen
}: ConfirmDeleteCommentModalWrapperProps) => {
  const [deleteComment] = useDeleteCommentMutation()
  const { hideModal } = useModal()

  const deleteUpdate: MutationUpdaterFn<DeleteCommentMutation> = (cache, { data }) => {
    if (data?.deleteComment.success) {
      const commentFragment = cache.readFragment<BoardCommentFragment>({
        id: `Comment:${id}`,
        fragment: BoardCommentFragmentDoc,
        fragmentName: 'boardComment'
      })

      if (commentFragment) {
        cache.modify({
          id: `PlanGroup:${commentFragment.groupId}`,
          fields: {
            comments(existingRefs: Reference[], { readField }) {
              // remove deleted comment
              return existingRefs.filter((ref) => readField('id', ref) !== id)
            }
          }
        })
      }
    }
  }

  const onConfirm = () => {
    hideModal()
    deleteComment({
      variables: { input: id },
      update: deleteUpdate,
      optimisticResponse: {
        __typename: 'Mutation',
        deleteComment: {
          __typename: 'ResponseStatus',
          id,
          message: '',
          success: true
        }
      }
    })
  }

  return <ConfirmDeleteCommentModal isOpen={isOpen} onConfirm={onConfirm} />
}

export default ConfirmDeleteCommentModalWrapper
